import { useContext } from 'react'
import { AuthContext } from 'store'
import { apiRoutes } from 'config/apiRoutes'
import { useOptions } from 'shared/hooks/useOptions'
import type { RentalItem } from 'features/rentals'
import type { AreaItem } from 'features/areas'

export const rentalOptionLabel = (rental: RentalItem, daysLabel: string) =>
	`${rental.booth_type_name?.name ?? 'None'} - ${rental.duration} ${daysLabel}`

export const boothOptionLabel = (booth: AreaItem) =>
	`#${booth.number} ${booth.booth_type_name ?? ''}`.trim()

export const useBookingOptions = ({ daysLabel }: { daysLabel: string }) => {
	const { auth } = useContext(AuthContext)
	const enabled = !!auth.accessToken

	return {
		rentals: useOptions<RentalItem>({
			name: 'fetchBookingRentals',
			endpoint: apiRoutes.rentals(),
			query: 'is_active=true',
			enabled,
			getLabel: (rental) => rentalOptionLabel(rental, daysLabel)
		}),
		booths: useOptions<AreaItem>({
			name: 'fetchBookingAreas',
			endpoint: apiRoutes.areas(),
			enabled,
			getLabel: boothOptionLabel
		})
	}
}
